<template>
    <div class="modal_bg" @click="fnEvent(false)"></div>
    <div class="modal_layer">
        <div class="modal_title">
            API 충전 이력 {{ props.isEdit ? "수정" : "등록" }}
            <div class="close_btn" @click="fnEvent(false)">
                <img src="@/assets/common/close.png" alt="" />
            </div>
        </div>
        <form action="">
            <div class="modal_content">
                <div class="user_modal">
                    <div>
                        <p>구매일</p>
                        <input
                            type="date"
                            placeholder="구매일"
                            v-model="info.createDate"
                            style="box-sizing: border-box; font-family: &quot;Neo&quot;"
                        />
                    </div>
                    <div>
                        <p>결제 금액($)</p>
                        <input type="text" placeholder="결제 금액" v-model.number="info.price" @input="onlyNumInput" />
                    </div>
                    <div>
                        <p>결과 건수</p>
                        <input type="text" placeholder="결과 건수" v-model.number="info.count" @input="onlyNumInput" />
                    </div>
                    <div>
                        <p>내용</p>
                        <textarea placeholder="내용" v-model="info.content"></textarea>
                    </div>
                </div>
                <div class="modal_btns">
                    <div class="modal_btn" @click="fnEvent(true)">{{ props.isEdit ? "수정" : "등록" }}</div>
                    <div class="modal_btn" @click="fnEvent(false)">취소</div>
                </div>
            </div>
        </form>
    </div>
</template>
<script lang="ts">
    import { formatDate2, onMounted, onlyNumInput, reactive, watch } from "@/BaseComponent";

    export default {
        props: ["info", "isEdit"],
        emits: ["close"],
        setup(props: any, { emit }: any) {
            const info = reactive({
                idx: 0 as number,
                price: "" as number | "",
                count: "" as number | "",
                content: "" as string,
                createDate: "" as string,
            });

            onMounted(() => {
                if (props.info) {
                    info.idx = props.info.idx;
                    info.price = props.info.price;
                    info.count = props.info.count;
                    info.content = props.info.content;
                    info.createDate = formatDate2(props.info.createDate);
                }
            });

            watch(
                () => props.info,
                () => {
                    if (props.info) {
                        info.idx = props.info.idx;
                        info.price = props.info.price;
                        info.count = props.info.count;
                        info.content = props.info.content;
                        info.createDate = formatDate2(props.info.createDate);
                    }
                },
            );

            const fnEvent = (result: boolean) => {
                if (result) {
                    if (!info.price) return alert("결제 금액을 입력해주세요");
                    if (info.price > 10000) return alert("결제 금액은 최대 $ 10,000 입니다.");
                    else if (!info.count) return alert("결과 건수를 입력해주세요");
                    else if (info.count > 100000) return alert("결과 건수는 최대 100,000건 입니다.");
                }

                const data = {
                    result,
                    info,
                };
                emit("close", data);
            };

            return { props, info, fnEvent, onlyNumInput };
        },
    };
</script>

<style scoped>
    .modal_content > .user_modal > div > input {
        height: auto;
    }
    .modal_btns {
        display: flex;
        flex-direction: row;
        gap: 20px;
        align-items: center;
        justify-content: center;
    }
    .modal_btns .modal_btn {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .modal_content > .user_modal > div > textarea {
        height: 350px;
    }
</style>
